var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComponent491(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.061,
    height: 39.061,
    viewBox: "0 0 39.061 39.061",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_49_1",
    "data-name": "Component 49 \\u2013 1",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_712",
    "data-name": "Group 712",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M221.156,166.566h0a19.03,19.03,0,0,1-19.03-19.03h0a19.03,19.03,0,0,1,19.03-19.031h0a19.03,19.03,0,0,1,19.031,19.031h0A19.03,19.03,0,0,1,221.156,166.566Z",
    transform: "translate(-202.126 -128.505)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_157",
    "data-name": "Group 157",
    transform: "translate(-202.126 -128.505)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M221.156,138.981c2.786,0,3.116.011,4.217.061a5.781,5.781,0,0,1,1.937.36,3.449,3.449,0,0,1,1.98,1.98,5.781,5.781,0,0,1,.36,1.937c.05,1.1.061,1.431.061,4.217s-.011,3.116-.061,4.216a5.782,5.782,0,0,1-.36,1.938,3.449,3.449,0,0,1-1.98,1.98,5.762,5.762,0,0,1-1.937.359c-1.1.05-1.43.061-4.217.061s-3.116-.011-4.216-.061A5.769,5.769,0,0,1,215,155.67a3.456,3.456,0,0,1-1.98-1.98,5.763,5.763,0,0,1-.359-1.938c-.05-1.1-.061-1.43-.061-4.216s.011-3.116.061-4.217a5.762,5.762,0,0,1,.359-1.937A3.456,3.456,0,0,1,215,139.4a5.789,5.789,0,0,1,1.938-.36c1.1-.05,1.43-.061,4.216-.061m0-1.88c-2.834,0-3.189.013-4.3.063a7.672,7.672,0,0,0-2.533.485,5.336,5.336,0,0,0-3.051,3.052,7.64,7.64,0,0,0-.485,2.533c-.051,1.113-.063,1.468-.063,4.3s.012,3.189.063,4.3a7.64,7.64,0,0,0,.485,2.533,5.336,5.336,0,0,0,3.051,3.052,7.7,7.7,0,0,0,2.533.485c1.113.05,1.468.062,4.3.062s3.189-.012,4.3-.062a7.692,7.692,0,0,0,2.533-.485,5.341,5.341,0,0,0,3.052-3.052,7.666,7.666,0,0,0,.485-2.533c.051-1.113.063-1.468.063-4.3s-.012-3.189-.063-4.3a7.666,7.666,0,0,0-.485-2.533,5.341,5.341,0,0,0-3.052-3.052,7.666,7.666,0,0,0-2.533-.485c-1.113-.05-1.468-.063-4.3-.063",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M221.156,142.178a5.358,5.358,0,1,0,5.358,5.358,5.358,5.358,0,0,0-5.358-5.358m0,8.836a3.478,3.478,0,1,1,3.478-3.478,3.478,3.478,0,0,1-3.478,3.478",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M227.978,141.966a1.252,1.252,0,1,1-1.252-1.252,1.252,1.252,0,0,1,1.252,1.252",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent491);
export default __webpack_public_path__ + "static/media/Component49–1.92c5267e9513de0fceace01e05c242b9.svg";
export { ForwardRef as ReactComponent };